export const getAsQueryParams = (
  obj: Record<string, boolean | null | number | string | undefined>,
): URLSearchParams => {
  const queryParams = new URLSearchParams();

  for (const [key, value] of Object.entries(obj)) {
    if (value !== undefined) {
      queryParams.append(key, String(value));
    }
  }

  return queryParams;
};
